import { useCallback, useState } from "react";

const useFocusedRowHighlight = () => {
  const [focusedRowKey, setFocusedRowKey] = useState(null);

  const handleRowFocus = useCallback((e) => {
    const rowKey = e.currentTarget?.dataset?.rowKey ?? null;
    setFocusedRowKey(rowKey);
  }, []);

  const handleRowBlur = useCallback((e) => {
    const rowKey = e.currentTarget?.dataset?.rowKey ?? null;
    const nextFocusedElement = e.relatedTarget;

    if (!e.currentTarget?.contains(nextFocusedElement)) {
      setFocusedRowKey((prev) => (prev === rowKey ? null : prev));
    }
  }, []);

  const getRowProps = useCallback(
    (rowKey, baseClassName = "") => {
      const key = String(rowKey ?? "");
      const className = `${baseClassName} ${focusedRowKey === key ? "erp-row-focus" : ""}`.trim();

      return {
        "data-row-key": key,
        onFocus: handleRowFocus,
        onBlur: handleRowBlur,
        className,
      };
    },
    [focusedRowKey, handleRowBlur, handleRowFocus]
  );

  return { focusedRowKey, getRowProps };
};

export default useFocusedRowHighlight;
